/* @flow weak */

import React from "react";
import createReactClass from "create-react-class";
import Reflux from "reflux";
import _ from "lodash";
import { Store } from "./Store";
import { IntlRootMixin } from "../IntlRootMixin";

const stores: { [name: string]: any } = {};

export const registerStore = function(name: string, store: Store) {
    stores[name] = store;
};

const actions: { [name: string]: any } = {};

export const registerActions = function(name: string, actionObject: any) {
    actions[name] = actionObject;
};

function handleStore(handler: any, store: any, props: any) {
    if (_.isFunction(handler)) {
        return handler(store, props);
    } else if (_.isArray(handler) && _.isFunction(store.getInitialState)) {
        return _.pick(store.getInitialState(), handler);
    } else {
        return {};
    }
}

function handleActions(handler: any, actionObject: any) {
    if (_.isArray(handler)) {
        return _.pick(actionObject, handler);
    } else {
        return {};
    }
}

function checkSpec(spec: any) {
    let bad = false;

    const knownOptions = ["stores", "actions"];
    const unknownOptions = _.difference(_.keys(spec), knownOptions);
    if (unknownOptions.length > 0) {
        bad = true;
        console.error("Bad connect spec: unknown options:", unknownOptions);
    }

    _.forEach(spec.stores, (handler, key) => {
        if (!stores[key]) {
            bad = true;
            console.error("Bad connect spec: unknown store:", key);
        }
        if (!_.isFunction(handler) && !_.isArray(handler)) {
            bad = true;
            console.error("Bad connect spec: bad store handler:", key);
        }
    });

    _.forEach(spec.actions, (handler, key) => {
        if (!actions[key]) {
            bad = true;
            console.error("Bad connect spec: unknown action:", key);
        }
        if (!_.isArray(handler)) {
            bad = true;
            console.error("Bad connect spec: bad action handler:", key);
        }
    });

    if (bad) {
        throw new Error("Bad connect spec");
    }
}

export const connect = function<Props, T>(
    spec: any,
    Component: React.ComponentType<Props> & T,
    addIntlRoot?: boolean
): React.ComponentType<Partial<Props>> & { WrappedComponent: T } {
    checkSpec(spec);

    const displayName = Component.displayName || (typeof Component === "function" ? Component.name : "");

    const addedMixins = [Reflux.ListenerMixin];
    if (addIntlRoot) {
        addedMixins.push(IntlRootMixin);
    }

    const Wrapper = createReactClass({
        mixins: addedMixins,

        displayName: displayName + "Wrapper",

        componentWillMount() {
            _.forEach(spec.stores || {}, (handler, key) => {
                const store = this.getStore(key);
                this.listenTo(store, () => {
                    // We just get the data directly from the stores without
                    // saving it in state, so here we just do a forceUpdate. If
                    // we want to do something more advanced here, it would be
                    // easy to switch though.
                    this.forceUpdate();
                });
            });
        },

        getStore(key: string) {
            // Here we could also allow replacing the store by a mock, perhaps
            // even via context to allow mocking deeper within the hierarchy
            return stores[key];
        },

        getActions(key: string) {
            // See above
            return actions[key];
        },

        render() {
            let props = _.reduce(
                spec.stores,
                (result, handler, storeKey) => {
                    return _.defaults(result, handleStore(handler, this.getStore(storeKey), this.props));
                },
                _.clone(this.props)
            );
            props = _.reduce(
                spec.actions,
                (result, handler, actionKey) => {
                    return _.defaults(result, handleActions(handler, this.getActions(actionKey)));
                },
                props
            );
            // @ts-ignore
            return React.createElement(Component, props);
        }
    });
    (Wrapper as any).WrappedComponent = Component;
    return Wrapper as any;
};
